"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DefrostingProcess = function DefrostingProcess(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.51,12.51,0,0,1,12.5,25Zm0-24A11.5,11.5,0,1,0,24,12.5,11.51,11.51,0,0,0,12.5,1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.4,16.08H4.6a.5.5,0,0,1-.5-.5V7.42a.5.5,0,0,1,.5-.5H20.4a.5.5,0,0,1,.5.5v8.15A.5.5,0,0,1,20.4,16.08Zm-15.3-1H19.9V7.92H5.1Z",
    fill: "#2c9fda"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.8,21.49a3.43,3.43,0,0,1,0-3.83,2.75,2.75,0,0,0,0-2.87,6.34,6.34,0,0,1-.45-2.15l1,0a5.68,5.68,0,0,0,.34,1.73,3.69,3.69,0,0,1-.06,3.9,2.45,2.45,0,0,0,0,2.68Z",
    fill: "#2c9fda"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "9.97 13.18 9.22 11.02 7.72 12.75 9.97 13.18",
    fill: "#2c9fda"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.08,21.49a3.43,3.43,0,0,1,0-3.83,2.75,2.75,0,0,0,0-2.87,6.34,6.34,0,0,1-.45-2.15l1,0A5.68,5.68,0,0,0,13,14.34a3.69,3.69,0,0,1-.06,3.9,2.45,2.45,0,0,0,0,2.68Z",
    fill: "#2c9fda"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "13.25 13.18 12.49 11.02 11 12.75 13.25 13.18",
    fill: "#2c9fda"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.36,21.49a3.43,3.43,0,0,1,0-3.83,2.75,2.75,0,0,0,0-2.87,6.34,6.34,0,0,1-.45-2.15l1,0a5.68,5.68,0,0,0,.34,1.73,3.69,3.69,0,0,1-.06,3.9,2.45,2.45,0,0,0,0,2.68Z",
    fill: "#2c9fda"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "16.53 13.18 15.77 11.02 14.28 12.75 16.53 13.18",
    fill: "#2c9fda"
  }));
};

var _default = DefrostingProcess;
exports["default"] = _default;